import { Button, IconText } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useExcelUpload from "./useExcelUpload";

const ExcelUpload = ({ receiptId, handleClose, onUploaded }) => {
  const { loading, formik, handleExcelUpload, getFieldError } = useExcelUpload({
    receiptId,
    handleClose,
    onUploaded,
  });

  return (
    <>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="excel_file" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Excel Upload
        </label>
        <div className="input-drag">
          <input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            className={`pro-input lg ${getFieldError("excel_file") && " error"}`}
            id="excel_file"
            onBlur={formik.handleBlur("excel_file")}
            onChange={(e) => handleExcelUpload(e)}
          />
          <span className="input-drag-box" style={{ padding: "50px" }}>
            {formik?.values?.excel_file?.name ? (
              formik?.values?.excel_file?.name
            ) : (
              <IconText title={`Drop files to attach or browse`} />
            )}
          </span>
          {getFieldError("excel_file") && (
            <span className="error-text">{getFieldError("excel_file")}</span>
          )}
        </div>
      </div>
      <div className="col-12 pro-d-flex pro-justify-end offcanvas-footer-sticky-btn">
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3 ${loading && "loading"}`}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Submit
        </Button>
      </div>
    </>
  );
};

export default ExcelUpload;
